import { FC } from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const Logo: FC<LogoProps> = ({ width = 64, height = 64, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 64 64"
      className={className}
    >
      {/* Gradient definitions */}
      <defs>
        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1a1a2e" />
          <stop offset="100%" stopColor="#0f0f23" />
        </linearGradient>
        <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#9FEF00" />
          <stop offset="100%" stopColor="#8bc34a" />
        </linearGradient>
      </defs>

      {/* Main rounded square with subtle shadow */}
      <rect
        x="6"
        y="6"
        width="52"
        height="52"
        rx="12"
        ry="12"
        fill="url(#bgGradient)"
        stroke="url(#greenGradient)"
        strokeWidth="2"
        filter="drop-shadow(0 2px 8px rgba(0,0,0,0.3))"
      />

      {/* Smiley face with mathematical symbols as eyes */}
      <g transform="translate(32, 32)">
        {/* Left eye - Plus symbol */}
        <g transform="translate(-7, -6)">
          <line
            x1="0"
            y1="-3.5"
            x2="0"
            y2="3.5"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.9"
          />
          <line
            x1="-3.5"
            y1="0"
            x2="3.5"
            y2="0"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.9"
          />
        </g>

        {/* Right eye - Multiplication symbol */}
        <g transform="translate(7, -6)">
          <line
            x1="-2.5"
            y1="-2.5"
            x2="2.5"
            y2="2.5"
            stroke="url(#greenGradient)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="2.5"
            y1="-2.5"
            x2="-2.5"
            y2="2.5"
            stroke="url(#greenGradient)"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>

        {/* Smile */}
        <path
          d="M -8 8 Q 0 16 8 8"
          stroke="url(#greenGradient)"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          opacity="0.9"
        />

        {/* Small nose dot (optional) */}
        <circle
          cx="0"
          cy="1"
          r="0.8"
          fill="#FFFFFF"
          opacity="0.4"
        />
      </g>
    </svg>
  );
};

export default Logo;